'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var cx = require('classnames');
var Tabs_module = require('./Tabs.module.scss.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var cx__default = /*#__PURE__*/_interopDefault(cx);

var TabNav = function (_a) {
    var _b;
    var children = _a.children, className = _a.className;
    var numberOfTabs = react.Children.toArray(children).length;
    return (jsxRuntime.jsx("nav", { children: jsxRuntime.jsx("ol", tslib.__assign({ role: "tablist", className: cx__default.default('d-flex flex-row px-3 m-0', Tabs_module.default['tab-nav'], (_b = {},
                _b[Tabs_module.default['two-tabs']] = numberOfTabs === 2,
                _b), className) }, { children: children })) }));
};

exports.TabNav = TabNav;
//# sourceMappingURL=TabNav.js.map
